import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getMonthlyRevenue({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query (
        $logistic_providers: [Int],
        $warehouses: [Int]
      ) {
        reconAnalyticsMonthlyRevenue(
          logistic_providers: $logistic_providers,
          warehouses: $warehouses
        ) {
          date
          value
        }
      }`, params)
    .then(({ data }) => {
      const { reconAnalyticsMonthlyRevenue } = data || {};

      commit('setMonthlyRevenue', reconAnalyticsMonthlyRevenue || []);
      commit('toggleLoading', false);
    })
    .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-monthly-revenue/store/actions.js